import { Helmet } from "react-helmet-async";

import Hero from "../components/Hero";
import FeaturedHotels from "../components/FeaturedHotels";
import PopularDestinations from "../components/PopularDestinations";
import WhyChooseUs from "../components/WhyChooseUs";
import Testimonials from "../components/Testimonials";
import TrustedPartners from "../components/TrustedPartners";
import HomeLatestBlogs from "../components/HomeLatestBlogs";

export default function Home() {
    return (
        <>
            <Helmet>
                {/* Basic SEO */}
                <title>
                    UAE Dubai Hotels | Best Hotels in Dubai & Luxury Hotel Booking UAE
                </title>

                <meta
                    name="description"
                    content="Discover the best hotels in Dubai and across the UAE. Book luxury, business, family, and budget hotels with UAE Dubai Hotels. Enjoy competitive rates, exclusive deals, and secure online reservations."
                />

                <meta
                    name="keywords"
                    content="UAE Dubai Hotels, Dubai hotels, hotels in Dubai, luxury hotels Dubai, hotel booking Dubai, UAE hotels, business hotels Dubai, family hotels Dubai, budget hotels UAE, Dubai accommodation, hotel deals Dubai"
                />

                <meta name="robots" content="index, follow" />
                <meta name="author" content="UAE Dubai Hotels" />

                {/* Canonical */}
                <link
                    rel="canonical"
                    href="https://uaedubaihotels.com/"
                />

                {/* Open Graph */}
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="UAE Dubai Hotels" />
                <meta property="og:locale" content="en_US" />

                <meta
                    property="og:title"
                    content="UAE Dubai Hotels | Best Hotels in Dubai & Luxury Hotel Booking UAE"
                />

                <meta
                    property="og:description"
                    content="Book luxury, business, family, and budget hotels in Dubai and across the UAE with secure online reservations and exclusive hotel offers."
                />

                <meta
                    property="og:url"
                    content="https://uaedubaihotels.com/"
                />

                <meta
                    property="og:image"
                    content="https://uaedubaihotels.com/images/default-og.png"
                />

                {/* Twitter */}
                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="UAE Dubai Hotels | Best Hotels in Dubai & Luxury Hotel Booking UAE"
                />

                <meta
                    name="twitter:description"
                    content="Find and book the best hotels in Dubai and across the UAE with exclusive offers, competitive prices, and secure online booking."
                />

                <meta
                    name="twitter:image"
                    content="https://uaedubaihotels.com/images/default-og.png"
                />
            </Helmet>

            <div className="bg-gray-50 dark:bg-gray-950">
                <Hero />
                <FeaturedHotels limit={8} />
                <PopularDestinations />
                <WhyChooseUs />
                <Testimonials />
                <TrustedPartners />
                <HomeLatestBlogs />
            </div>
        </>
    );
}